/**
 * Map propertydetail area field keys → form input field keys
 * (property uses land_area1; detail config uses land_area)
 */
export const DETAIL_TO_INPUT_FIELD = {
  land_area: 'land_area1',
  buildup_area: 'buildup_area',
  carpet_area: 'carpet_area',
  plot_area: 'plot_area',
};

export const INPUT_TO_DETAIL_FIELD = {
  land_area1: 'land_area',
  buildup_area: 'buildup_area',
  carpet_area: 'carpet_area',
  plot_area: 'plot_area',
  land_area_cent: 'land_area', // legacy project form field maps to Land Area display
};

export const normalizeInputsList = (raw) => {
  if (!raw) return [];
  if (Array.isArray(raw)) return raw.filter(Boolean);
  if (typeof raw === 'object') return Object.values(raw).filter(Boolean);
  return [];
};

export const findInputByField = (inputs, fieldKey) => {
  const list = normalizeInputsList(inputs);
  return list.find((f) => f && String(f.field) === String(fieldKey)) || null;
};

export const getInputFieldKeyForDetail = (detailFieldKey, isProject = false) => {
  if (!detailFieldKey) return null;
  if (detailFieldKey === 'land_area' && isProject) {
    // Projects historically used land_area_cent range fields
    return 'land_area_cent';
  }
  return DETAIL_TO_INPUT_FIELD[detailFieldKey] || detailFieldKey;
};

export const getLandtypeIdsForAreaField = (inputs, detailFieldKey, isProject = false) => {
  const candidates = [
    getInputFieldKeyForDetail(detailFieldKey, isProject),
    detailFieldKey,
    detailFieldKey === 'land_area' ? 'land_area1' : null,
    detailFieldKey === 'land_area' ? 'land_area_cent' : null,
  ].filter(Boolean);

  for (const key of candidates) {
    const input = findInputByField(inputs, key);
    if (input && Array.isArray(input.landtype_ids) && input.landtype_ids.length) {
      return input.landtype_ids.map(Number).filter(Number.isFinite);
    }
  }
  return null; // null = all land types allowed
};

export const filterLandtypesByIds = (landtypes, allowedIds) => {
  const list = Array.isArray(landtypes) ? landtypes : [];
  if (!Array.isArray(allowedIds) || !allowedIds.length) return list;
  const set = new Set(allowedIds.map(Number));
  return list.filter((l) => set.has(Number(l.id)));
};
